import src from "IMAGE";
export default { src, width: 1254, height: 408, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAARElEQVR42m2LsREAERQFfyV3c2eI6UFDQhXwE7VJhSIJMzp45ASb7M6S4IknnPzby9hBH9+j4QbtC+i93IoHbKrQLmMB29o9+Dk4ynoAAAAASUVORK5CYII="};
